import { __assign, __extends } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-skeleton.css';

var getClassNameList = classNames.bind(styles);
var UitkSkeleton = function (props) {
    var className = props.className, animation = props.animation;
    var wrapperClassNames = getClassNameList(UitkSkeleton.baseClassName, className, animation && UitkSkeleton.baseClassName + "-animation");
    return React.createElement("div", { className: wrapperClassNames, role: "presentation" });
};
UitkSkeleton.baseClassName = 'uitk-skeleton';
UitkSkeleton.defaultProps = {
    animation: true
};
UitkSkeleton.displayName = 'UitkSkeleton';

var UitkBlockSkeleton = function (props) {
    var animation = props.animation, className = props.className, type = props.type;
    var cssClassNames = classNames(UitkSkeleton.baseClassName + "-block", type && UitkSkeleton.baseClassName + "-block-" + type, className);
    return React.createElement(UitkSkeleton, { className: cssClassNames, animation: animation });
};
UitkBlockSkeleton.displayName = 'UitkBlockSkeleton';
UitkBlockSkeleton.defaultProps = {
    type: 'square'
};
var UitkImageSkeleton = function (props) { return React.createElement(UitkBlockSkeleton, __assign({}, props)); };
UitkImageSkeleton.displayName = 'UitkImageSkeleton';

var UitkLineSkeleton = function (props) {
    var animation = props.animation, className = props.className, type = props.type;
    var wrapperClassNames = classNames(UitkSkeleton.baseClassName + "-line", type && UitkSkeleton.baseClassName + "-line-" + type, className);
    return React.createElement(UitkSkeleton, { className: wrapperClassNames, animation: animation });
};
UitkLineSkeleton.displayName = 'UitkLineSkeleton';
UitkLineSkeleton.defaultProps = {
    type: 'primary'
};
var UitkTextSkeleton = function (props) { return React.createElement(UitkLineSkeleton, __assign({}, props)); };
UitkTextSkeleton.displayName = 'UitkTextSkeleton';

var UitkIconSkeleton = /** @class */ (function (_super) {
    __extends(UitkIconSkeleton, _super);
    function UitkIconSkeleton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkIconSkeleton.prototype.render = function () {
        var props = this.props;
        var cssClassNames = classNames(UitkSkeleton.baseClassName + "-icon", props.className);
        return React.createElement(UitkSkeleton, { className: cssClassNames, animation: props.animation });
    };
    UitkIconSkeleton.displayName = 'UitkIconSkeleton';
    return UitkIconSkeleton;
}(React.PureComponent));

export { UitkBlockSkeleton, UitkIconSkeleton, UitkImageSkeleton, UitkLineSkeleton, UitkTextSkeleton };
